module.exports = __webpack_public_path__ + "static/media/option10.e99af55f.png";